import PropTypes from 'prop-types'
import {
    wordsListsLoadingStatusSelector,
    setWordListsRoutine
} from '../../../../../store/wordLists'
import '../../../../../styles/scss/pages/dictionary/card-list/card-list.scss'
import NotificationsUtils from '../../../../utils/NotificationsUtils'
import UrlUtils from '../../../../utils/UrlUtils'
import WordListUtils from '../../../../utils/WordListUtils'
import WordListItem from './WordListItem'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import MockWordList from "./MockWordList";

const WordLists = (props: any) => {
    const dispatch = useAppDispatch()
    const isWordListsLoading = useAppSelector(wordsListsLoadingStatusSelector)
    const { wordLists, canEditCommunity } = props


    /**
     * Изменить название списка
     * @param e
     * @param id
     */
    const onChangeListName = (e: any, id: any) => {
        const listName = e.target.value
        const newWordList = wordLists.map((wordList: any) => {
            if (wordList.id === id) {
                return { ...wordList, listName }
            }
            return wordList
        })
        dispatch(setWordListsRoutine(newWordList))
    }

    /**
     * Изменить уровень списка слов
     * @param e
     * @param id
     */
    const onChangeListLevel = (e: any, id: any) => {
        const level = e.target.value
        const newWordList = wordLists.map((wordList: any) => {
            if (wordList.id === id) {
                return { ...wordList, level }
            }
            return wordList
        })
        dispatch(setWordListsRoutine(newWordList))
    }

    /**
     * Отменить редактирование
     * @param id
     */
    const cancelEdit = (id: any) => {
        let newWordList
        if (WordListUtils.isNewEntity(id)) {
            newWordList = wordLists.filter((wordList: any) => wordList.id !== id)
        } else {
            newWordList = wordLists.map((wordList: any) => {
                if (wordList.id === id) {
                    return {
                        ...wordList,
                        listName: wordList.prevListName,
                        editMode: false
                    }
                }
                return wordList
            })
        }
        dispatch(setWordListsRoutine(newWordList))
    }

    /**
     * Поделиться сообществом
     */
    const shareWordList = (wlId: any) => {
        navigator.clipboard
            .writeText(UrlUtils.createShareListUrl(props.inviteKey, wlId))
            .then(() => {
                NotificationsUtils.openSuccessNotification('Ссылка скопирована!')
            })
            .catch(() => {
                NotificationsUtils.openErrorNotification('Не удалось скопировать ссылку')
            })
    }

    return (
        <div className='dictionary_right_bar'>
            <div
                className={'dictionary_right_bar--wls ' + (props.isCommunity && 'dictionary_right_bar--wls-community')}
            >
                {isWordListsLoading ? (
                    <>
                        {[...Array(3)].map((_, idx) => (
                            <MockWordList/>
                        ))}
                    </>
                ) : (
                    wordLists
                        .filter(
                            (wl: any) =>
                                (props.isCommunity && wl.communityId === props.communityId) ||
                                (!props.isCommunity) && !wl.communityId
                        )
                        .map((wordList: any) => (
                            <WordListItem
                                key={wordList.id}
                                wordList={wordList}
                                onChangeListName={onChangeListName}
                                onChangeListLevel={onChangeListLevel}
                                shareWordList={shareWordList}
                                cancelEdit={cancelEdit}
                                canEditCommunity={canEditCommunity}
                            />
                        ))
                )}
            </div>
        </div>
    )
}

export default WordLists

WordLists.propTypes = {
    wordLists: PropTypes.array,
    user: PropTypes.object,
    activeCommunity: PropTypes.object,
    canEditCommunity: PropTypes.bool,
    isCommunity: PropTypes.bool.isRequired,
    inviteKey: PropTypes.string,
    communityId: PropTypes.number
}